<template>
  <RfChartsExtended
    ref="chartsRef"
    :data="lineDatasets"
    :hasData="lineHasData"
    :skeleton="skeleton"
    alterNoData
  />
</template>

<script setup>
import { computed, ref } from "vue";
import { chartColors } from "@/utils/constants/ColorsConstants";
import { percentage } from "@/utils/metricsHelpers";
import RfChartsExtended from "../RfCharts/RfChartsExtended.vue";

const props = defineProps({
  metrics: { type: Object, default: () => ({}) },
  metricsKey: { type: String, default: "since_start_date" },
  path: { type: Object, default: () => ({}) },
  skeleton: { type: Boolean, default: false },
});

const chartsRef = ref(null);

const currentMetric = computed(() => props.metrics[props.metricsKey]);
const variants = computed(() => currentMetric.value?.data?.filter(v => !v.is_control) ?? []);

const selectedVariantId = computed(() => {
  const key = chartsRef.value?.selectedChartKey;
  return key ? (variants.value[key - 1]?.id ?? null) : null;
});

const lineDatasets = computed(() => {
  if (!variants.value.length) return [];

  const colors = [...chartColors];

  return variants.value.map(variant => {
    const uimpData = variant.uimpressions?.data || [];
    const goalsData = variant.goals?.data || [];

    const totalU = uimpData.reduce((s, d) => s + d.count, 0);
    const totalG = goalsData.reduce((s, d) => s + d.count, 0);

    const color = colors.splice(Math.floor(Math.random() * colors.length), 1)[0];
    return {
      label: variant.name,
      data: uimpData.map((d, i) => ({
        key: d.date,
        value: { label: percentage(goalsData[i]?.count ?? 0, d.count), raw: 0 },
      })),
      backgroundColor: color,
      borderColor: color,
      type: "line",
      order: 0,
      parsing: { xAxisKey: "key", yAxisKey: "value.raw" },
      props: { type: "percentage" },
      totals: { text: percentage(totalG, totalU, true), value: percentage(totalG, totalU) },
    };
  });
});

const lineHasData = computed(() => lineDatasets.value.some(ds => ds.data?.length > 0));

defineExpose({ selectedVariantId, variants });
</script>
